import script from "./ErrorView.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorView.vue?vue&type=script&setup=true&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=ada3de62&lang=scss"

const __exports__ = script;

export default __exports__